import type { PlpRoot } from '@core/Entities/Search/PlpRoot.entity';

function getBasePathFromRoot(root: PlpRoot) {
  return `/cars/${root}`;
}

export { getBasePathFromRoot };
